import { render } from "./Companies.vue?vue&type=template&id=64cef7e1&scoped=true"
import script from "./Companies.vue?vue&type=script&lang=js"
export * from "./Companies.vue?vue&type=script&lang=js"

import "./Companies.vue?vue&type=style&index=0&id=64cef7e1&scoped=true&lang=css"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64cef7e1"]])

export default __exports__